export default __webpack_public_path__ + "static/media/7.02c3e554.jpg";